// import React, { useState, useEffect } from "react";
// import { Box, Card, CardContent, Typography } from "@mui/material";

// import UserWiseFilters from "./UserWiseFilters";
// import UserWiseTable from "./UserWiseTable";
// import Dialogs from "./Dialogs";
// import MainLayout from "../MainLayout";
// import '../Final_Css/positiveflowbuttons.css';
// import './UserwiseReports.css';

// export const ReportsUserWise = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filters, setFilters] = useState([]);

//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [totalCount, setTotalCount] = useState(0);
//   const [page, setPage] = useState(1);

//   const pageSize = 5;

//   // Dialog
//   const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [selectedExam, setSelectedExam] = useState(null);

//   const fetchReports = async (pageNum = 1) => {
//     try {
//       setLoading(true);

//       const difficulties = filters.filter(f =>
//         ["Beginner", "Intermediate", "Expert"].includes(f)
//       );

//       const examTypes = filters.filter(f =>
//         ["Viva", "Theory"].includes(f)
//       );

//       const params = new URLSearchParams({
//         search: searchTerm,
//         page: pageNum,
//         page_size: pageSize,
//       });

//       if (difficulties.length > 0)
//         params.append("difficulty", difficulties.join(","));

//       if (examTypes.length > 0)
//         params.append("exam_type", examTypes.join(","));

//       const resp = await fetch(`/reports/user-wise/?${params}`);
//       const data = await resp.json();
//       console.log(data, "@@@@@@@@@")

//       setReports(data.reports || []);
//       setTotalCount(data.total_count || 0);
//       setPage(pageNum);

//     } catch (e) {
//       console.error("Error fetching reports:", e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReports(1);
//   }, [searchTerm, filters]);

//   return (
//     <>
//       {/* <MainLayout /> */}
//       <div style={{"justify-content": "flex-start"  }}>
//         <div className="reportsUserWise">
//           <Box className="MainSectionTop" sx={{ p: 3 }}>
//             <Card sx={{ background: "#fff", borderRadius: 2, boxShadow: 2 }}>
//               <CardContent>
//                 <Typography variant="h6" className="mb-3">
//                   Assessment Reports
//                 </Typography>

//                 <UserWiseFilters
//                   searchTerm={searchTerm}
//                   setSearchTerm={setSearchTerm}
//                   filters={filters}
//                   setFilters={setFilters}
//                 />

//                 <UserWiseTable
//                   reports={reports}
//                   loading={loading}
//                   page={page}
//                   setPage={(newPage) => fetchReports(newPage)}
//                   rowsPerPage={pageSize}
//                   totalCount={totalCount}
//                   setPdfDialogOpen={setPdfDialogOpen}
//                   setPdfUrl={setPdfUrl}
//                   setSelectedEmployee={setSelectedExam}
//                 />
//               </CardContent>
//             </Card>
//           </Box>

//           <Dialogs
//             pdfDialogOpen={pdfDialogOpen}
//             setPdfDialogOpen={setPdfDialogOpen}
//             pdfUrl={pdfUrl}
//             selectedEmployee={selectedExam}
//           />
//         </div>
//       </div>
//     </>

//   );
// };



import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

import UserWiseFilters from "./UserWiseFilters";
import UserWiseTable from "./UserWiseTable";
import Dialogs from "./Dialogs";
import MainLayout from "../MainLayout";
import '../Final_Css/positiveflowbuttons.css';
import './UserwiseReports.css';
import { useOutletContext, Navigate, useLocation } from "react-router-dom";
import axios from "axios";

export const ReportsUserWise = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState([]);               // existing dropdown filters
  const [filterRule, setFilterRule] = useState(null);       // QueryBuilder rule

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);

  const pageSize = 10;

  // Dialog
  const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [selectedExam, setSelectedExam] = useState(null);

  const fetchReports = async (pageNum = 1) => {
    try {
      setLoading(true);


      const examTypes = filters.filter(f =>
        ["Viva", "Theory"].includes(f)
      );

      const params = new URLSearchParams({
        search: searchTerm,
        page: pageNum,
        page_size: pageSize,
      });


      if (examTypes.length > 0)
        params.append("exam_type", examTypes.join(","));

      if (filterRule && filterRule.rules?.length) {
        params.append("filters", JSON.stringify(filterRule));
      }

      const resp = await axios.get(`/reports/user-wise/?${params}`, {
        withCredentials: true
      });
      const data = resp.data;
      console.log(data, "@@@@@@@@@");

      setReports(data.reports || []);
      setTotalCount(data.total_count || 0);
      setPage(pageNum);

    } catch (e) {
      console.error("Error fetching reports:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports(1);
  }, [searchTerm, filters, filterRule]);

   const { permissionSet, permissionsLoading } = useOutletContext();
   if (permissionsLoading) return <div>Loading...</div>;

    const canAccessAssessment = permissionSet.has(10);

    if (!canAccessAssessment) {
        return <Navigate to="/error" replace />;
    }

  return (
    <>
      <div style={{ justifyContent: "flex-start" }}>
        <div className="reportsUserWise">
          <Box className="MainSectionTop" sx={{ p: 3 }}>
            <Card sx={{ background: "#fff", borderRadius: 2, boxShadow: 2 }}>
              <CardContent>
                <Typography variant="h6" className="mb-3">
                  Assessment Reports
                </Typography>

                <UserWiseFilters
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  filters={filters}
                  setFilters={setFilters}
                  filterRule={filterRule}
                  setFilterRule={setFilterRule}      // new prop
                />

                <UserWiseTable
                  reports={reports}
                  loading={loading}
                  page={page}
                  setPage={(newPage) => fetchReports(newPage)}
                  rowsPerPage={pageSize}
                  totalCount={totalCount}
                  setPdfDialogOpen={setPdfDialogOpen}
                  setPdfUrl={setPdfUrl}
                  setSelectedEmployee={setSelectedExam}
                />
              </CardContent>
            </Card>
          </Box>

          <Dialogs
            pdfDialogOpen={pdfDialogOpen}
            setPdfDialogOpen={setPdfDialogOpen}
            pdfUrl={pdfUrl}
            selectedEmployee={selectedExam}
          />
        </div>
      </div>
    </>
  );
};
